var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.95 16.027h-3.3V8.013H0V5.25h1.65V3.593C1.65 1.34 2.581 0 5.226 0h2.203v2.762H6.053c-1.031 0-1.099.386-1.099 1.107L4.95 5.25h2.495l-.292 2.763H4.95v8.014","fill":"#FFF"}));
}

Facebook.displayName = "Facebook";

Facebook.defaultProps = {"height":"16px","viewBox":"0 0 7 16"};

module.exports = Facebook;

Facebook.default = Facebook;
